import { render, staticRenderFns } from "./inAppChangeNotificationSnackbar.vue?vue&type=template&id=2e530556&lang=pug"
import script from "./inAppChangeNotificationSnackbar.vue?vue&type=script&lang=js"
export * from "./inAppChangeNotificationSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports